import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { clientApplicationsRoute } from '../route';

export const clientPsd2ConnectedBanksSearchSchema = z.object({
	openedProviderCode: z.string().optional(),
});

export const clientPsd2ConnectedBanksRoute = createRoute({
	getParentRoute: () => clientApplicationsRoute,
	path: '/psd2-connected-banks',
	component: lazyRouteComponent(
		() => import('./ClientPsd2ConnectedBanksPage'),
		'ClientPsd2ConnectedBanksPage',
	),
	validateSearch: clientPsd2ConnectedBanksSearchSchema,
});
